const navbar = document.querySelector('.js-navbar');
const navbarToggles = [...document.querySelectorAll('.js-navbar-toggle')];
const links = [...navbar.querySelectorAll('a')];

navbarToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
        navbar.classList.toggle('is-open');
    });
});


links.forEach((link) => {
    link.addEventListener('click', () => {
        navbar.classList.remove('is-open');
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/navbar.js